<template>
  <div id="questionlib">
    <div class="lib-wrapper">
      <el-container class="lib-container">
        <el-aside class="lib-sider" style="width: 260px;">
          <h3 class="sider-title">{{ siderTitle }}</h3>
          <div v-if="!isClassic && !fixedCourseSerialnumber && chapter" class="course-list">
            <el-radio-group
              v-model="radio1"
              @change="onClickcourses()"
              class="course-radio-group"
            >
              <div v-for="item in coursesName" :key="item.serialnumber">
                <el-radio-button
                  :label="item.serialnumber"
                  class="course-radio-btn"
                  >{{ item.catalog }}</el-radio-button
                >
              </div>
            </el-radio-group>
          </div>
          <div v-else class="chapter-list">
            <el-button v-if="!isClassic && !fixedCourseSerialnumber" class="back-course-btn" @click="chapter = true"
              >返回科目</el-button
            >
            <el-menu
              class="menu-sider"
              unique-opened
              :default-active="activeKnowledgeSerialnumber"
            >
              <el-submenu
                class="el-menuitem-parent"
                v-for="(chap, i) in chaptersinfos"
                :key="i"
                :index="i.toString()"
              >
                <template slot="title"
                  ><span class="chap-title"
                    ><span v-text="textNum(i)"></span>{{ chap.chapter }}
                    <span
                      v-if="isClassic && chap.questionCount !== undefined"
                      class="count-badge"
                      :class="{ 'has-count': chap.questionCount > 0 }"
                    >({{ chap.questionCount }})</span>
                  </span
                ></template>
                <el-menu-item
                  class="el-menuitem-child"
                  v-for="(knowlg, j) in chap.knowledges"
                  :key="j"
                  :index="knowlg.serialnumber"
                  @click="onClickKnowledgeItem(knowlg.serialnumber)"
                >
                  <span class="knowlg-title">{{ knowlg.knowledge }}</span>
                  <span
                    v-if="isClassic && knowlg.questionCount !== undefined"
                    class="count-badge"
                    :class="{ 'has-count': knowlg.questionCount > 0 }"
                  >({{ knowlg.questionCount }})</span>
                </el-menu-item>
              </el-submenu>
            </el-menu>
          </div>
        </el-aside>
        <el-container class="main-container">
          <el-header class="lib-header" style="height: auto;">
            <div class="filter-row">
              <div class="filter-item">
                <span class="filter-label">题型</span>
                <el-select
                  v-model="selqtype"
                  :disabled="!hasKnowledgeQuestion"
                  @change="onfilterQtype"
                  class="filter-select"
                >
                  <el-option
                    v-for="(qtyp, i) in questypes"
                    :key="i"
                    :label="qtyp.lb"
                    :value="qtyp.index"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="filter-item">
                <span class="filter-label">难度</span>
                <el-select
                  v-model="sellevel"
                  :disabled="!hasKnowledgeQuestion"
                  @change="onfilterLevel"
                  class="filter-select"
                >
                  <el-option
                    v-for="(qtyp, i) in (isClassic ? classicDifficultyOptions : level)"
                    :key="i"
                    :label="qtyp.lb"
                    :value="qtyp.index"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>

            <div class="practice-stats-row" v-if="hasKnowledgeQuestion">
              <span class="practice-progress">
                练习进度: {{ practiceStats.answeredTotal }}/{{
                  practiceStats.questionTotal
                }}
                <el-divider direction="vertical"></el-divider>
                完成率: {{ practiceStats.completionRate }}%
                <el-divider direction="vertical"></el-divider>
                正确率: {{ practiceCorrectRate }}%
              </span>
            </div>
          </el-header>
          <el-main class="lib-main">
            <div style="flex: 1; overflow: hidden; height: 100%;">
              <el-table
                :data="questionsels"
                height="100%"
                id="lib-table"
                @current-change="handleTableCurrentChange"
                :border="false"
                v-loading.fullscreen.lock="lockscreen"
                stripe
                element-loading-text="加载题目......"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)"
                :row-class-name="getCellIndex"
                :header-cell-style="{
                  background: '#f5f7fa',
                  color: '#606266',
                  fontWeight: 'bold'
                }"
                class="custom-table"
              >
                <el-table-column
                  prop="id"
                  label="序号"
                  width="80"
                  header-align="center"
                  align="center"
                  fixed
                >
                </el-table-column>
                <el-table-column
                  label="题目"
                  header-align="center"
                  align="left"
                >
                  <template slot-scope="scope">
                    <div class="question-stem-container" :key="Xindex">
                      <qstem
                        v-katex
                        v-bind:question="scope.row"
                        v-bind:index="scope.id"
                        v-bind:showmode="showmode"
                      ></qstem>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  v-if="isClassic"
                  prop="vocationalKnowledgeName"
                  label="知识点"
                  min-width="140"
                  header-align="center"
                  align="center"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.vocationalKnowledgeName || '--' }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="level"
                  :label="isClassic ? '难度等级' : '难易度'"
                  width="100"
                  header-align="center"
                  align="center"
                >
                  <template slot-scope="scope">
                    <el-tag
                      v-if="isClassic && scope.row.difficultyLevel"
                      size="mini"
                      :type="getDifficultyTagType(scope.row.difficultyLevel)"
                    >
                      难度 {{ scope.row.difficultyLevel }}
                    </el-tag>
                    <span v-else class="level-tag">{{
                      getLevelText(scope.row.level)
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="qtype"
                  label="题型"
                  width="100"
                  header-align="center"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  label="操作"
                  width="220"
                  header-align="center"
                  align="center"
                >
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      class="action-btn"
                      @click.stop="sshow(scope.row)"
                      >练习</el-button
                    >
                    <el-button type="text" class="action-btn">附件</el-button>
                    <el-button
                      v-if="
                        ['解答题', '证明题', '综合题'].includes(scope.row.qtype)
                      "
                      type="text"
                      class="action-btn ai-action-btn"
                      @click.stop="openAiDialog(scope.row)"
                      >AI主观题解析</el-button
                    >
                    <el-button
                      v-if="
                        ['判断题', '单选题', '多选题'].includes(scope.row.qtype)
                      "
                      type="text"
                      class="action-btn ai-action-btn"
                      @click.stop="openAiObjDialog(scope.row)"
                      >AI解析</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <el-dialog
              title="题目自测"
              :visible.sync="dialogVisible1"
              width="50%"
              :before-close="handleClose"
              id="qsteam"
            >
              <div>
                <div
                  id="qsteam"
                  class="qcontent"
                  v-for="(rginfos, i) in question.steam"
                  :key="i"
                >
                  <span v-for="(item, j) in rginfos.wordInfos" :key="j">
                    <span v-if="item.wdType === 1" name="imglatex" v-katex
                      >${{ item.latex }}$</span
                    >
                    <img v-else-if="item.wdType === 2" :src="item.buffer" />
                    <span class="tex2jax_ignore" v-else>{{
                      item.content
                    }}</span>
                  </span>
                </div>
                <div>
                  <div
                    v-if="question.hasjudge"
                    style="display: block; text-align: left;margin-top:20px;"
                  >
                    <el-radio-group
                      v-model="question.radio"
                      class="el_radio_group wrap"
                    >
                      <div style="height: 30px">
                        <el-radio
                          :label="1"
                          class="el_radio wrap"
                          style="height: 20px"
                          :disabled="correct"
                        >
                          <span class="box"
                            ><i class="el-icon-circle-check"></i
                          ></span>
                          <img
                            v-show="question.judge == '正确' && correct == true"
                            src="../../assets/img/dui.png"
                            alt=""
                          />
                        </el-radio>
                      </div>
                      <br />
                      <div style="height: 30px">
                        <el-radio :label="0" class="el_radio">
                          <span class="box"
                            ><i class="el-icon-circle-close"></i
                          ></span>
                          <img
                            v-show="
                              question.judge !== '正确' && correct == true
                            "
                            src="../../assets/img/dui.png"
                            alt=""
                          />
                        </el-radio>
                      </div>
                    </el-radio-group>
                  </div>
                  <div
                    v-if="question.hasops"
                    class="qoption"
                    style="display: block; text-align: left"
                  >
                    <p class="qsplit" id="qsteam">【选项】</p>
                    <el-checkbox-group
                      v-model="question.multx"
                      class="el_radio_group"
                      v-if="question.qtype === '多选题'"
                      :key="Xindex"
                    >
                      <div
                        class="multx wrap"
                        v-for="(item, index) in question.options"
                        :key="index"
                      >
                        <el-checkbox
                          :label="orderList[index].label"
                          :style="{
                            background:
                              item.correct && correct
                                ? 'rgba(133, 206, 97, 0.51)'
                                : 'transparent'
                          }"
                          class="multx"
                          :disabled="correct"
                        >
                          <span class="labelbox"
                            >{{ orderList[index].label }}.{{ str }}</span
                          >
                          <span v-for="(t, i) in item.ranginfos" :key="i">
                            <span v-for="(it, j) in t.wordInfos" :key="j">
                              <span v-if="it.wdType === 1" v-katex
                                >${{ it.latex }}$</span
                              >
                              <img
                                v-else-if="it.wdType === 2"
                                :src="it.buffer"
                              />
                              <span v-else class="tex2jax_ignore">{{
                                it.content
                              }}</span>
                            </span>
                          </span>
                        </el-checkbox>
                      </div>
                    </el-checkbox-group>
                    <div v-else>
                      <el-radio-group
                        class="el_radio_group"
                        v-model="question.radio"
                        :key="Xindex"
                      >
                        <div
                          v-for="(item, index) in question.options"
                          :key="index"
                        >
                          <el-radio
                            :label="orderList[index].label"
                            class="el_radio"
                            :data-index="item.index"
                            :disabled="correct"
                            :style="{
                              background:
                                item.correct && correct
                                  ? 'rgba(133, 206, 97, 0.51)'
                                  : 'transparent'
                            }"
                          >
                            <span class="labelbox"
                              >{{ orderList[index].label }}.{{ str }}</span
                            >
                            <span v-for="(t, i) in item.ranginfos" :key="i">
                              <span v-for="(it, j) in t.wordInfos" :key="j">
                                <span v-if="it.wdType === 1" v-katex
                                  >${{ it.latex }}$</span
                                >
                                <img
                                  v-else-if="it.wdType === 2"
                                  :src="it.buffer"
                                />
                                <span v-else class="tex2jax_ignore">{{
                                  it.content
                                }}</span>
                              </span>
                            </span>
                          </el-radio>
                          <br />
                        </div>
                      </el-radio-group>
                    </div>
                  </div>
                  <div
                    v-if="question.hasfill && correct"
                    id="qsteam"
                    style=" text-align: left"
                  >
                    <p class="qsplit">【填空】</p>
                    <div>
                      <div
                        class="qcontent"
                        v-for="(slv, i) in question.fill"
                        :key="i"
                        id="qsteam"
                      >
                        <span v-for="(item, j) in slv.wordInfos" :key="j">
                          <span v-if="item.wdType === 1" name="imglatex" v-katex
                            >${{ item.latex }}$</span
                          >
                          <img
                            v-else-if="item.wdType === 2"
                            :src="item.buffer"
                          />
                          <span class="tex2jax_ignore" v-else>{{
                            item.content
                          }}</span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div v-if="question.hasslove" style="text-align:left;">
                    <p class="qsplit">【解析】</p>
                    <div
                      class="qcontent"
                      v-for="(slv, i) in question.slove"
                      :key="i"
                      id="qsteam"
                    >
                      <span v-for="(item, j) in slv.wordInfos" :key="j">
                        <span v-if="item.wdType === 1" name="imglatex" v-katex
                          >${{ item.latex }}$</span
                        >
                        <img v-else-if="item.wdType === 2" :src="item.buffer" />
                        <span class="tex2jax_ignore" v-else>{{
                          item.content
                        }}</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <span slot="footer" class="dialog-footer">
                <el-button @click="checkAnswer" type="success">提交</el-button>
                <el-button @click="last" :disabled="!submit">上一题</el-button>
                <el-button @click="next" :disabled="!submit">下一题</el-button>
                <el-button
                  v-show="correct == false"
                  type="primary"
                  :disabled="!submit && !isSubject"
                  @click="opendialogVisible"
                  >查看解析</el-button
                >
                <el-button
                  type="primary"
                  v-show="correct == true"
                  @click="handleClose"
                  >确定</el-button
                >
              </span>
            </el-dialog>
            <el-dialog
              title="AI解析"
              :visible.sync="aiDialogVisible"
              width="80%"
              top="6vh"
              :close-on-click-modal="false"
              :before-close="closeAiDialog"
              class="ai-analysis-dialog"
            >
              <div class="ai-analysis-layout">
                <div class="ai-panel">
                  <div class="ai-panel-header">题目内容</div>
                  <div class="ai-panel-body ai-panel-question">
                    <template
                      v-if="
                        aiQuestion &&
                          aiQuestion.steam &&
                          aiQuestion.steam.length
                      "
                    >
                      <div
                        class="ai-qcontent"
                        v-for="(rginfos, i) in aiQuestion.steam"
                        :key="'ai-stem-' + i"
                      >
                        <span
                          v-for="(item, j) in rginfos.wordInfos"
                          :key="'ai-stem-item-' + i + '-' + j"
                        >
                          <span v-if="item.wdType === 1" name="imglatex" v-katex
                            >${{ item.latex }}$</span
                          >
                          <img
                            v-else-if="item.wdType === 2"
                            :src="item.buffer"
                          />
                          <span class="tex2jax_ignore" v-else>{{
                            item.content
                          }}</span>
                        </span>
                      </div>

                      <div v-if="aiQuestion.hasjudge" class="ai-options-block">
                        <p class="ai-block-title">选项</p>
                        <div class="ai-option-line">A. 正确</div>
                        <div class="ai-option-line">B. 错误</div>
                      </div>

                      <div v-if="aiQuestion.hasops" class="ai-options-block">
                        <p class="ai-block-title">选项</p>
                        <div
                          class="ai-option-line"
                          v-for="(item, index) in aiQuestion.options"
                          :key="'ai-option-' + index"
                        >
                          <span class="ai-option-label"
                            >{{
                              orderList[index]
                                ? orderList[index].label
                                : index + 1
                            }}.</span
                          >
                          <span
                            v-for="(t, i) in item.ranginfos || []"
                            :key="'ai-option-range-' + index + '-' + i"
                          >
                            <span
                              v-for="(it, j) in t.wordInfos || []"
                              :key="
                                'ai-option-word-' + index + '-' + i + '-' + j
                              "
                            >
                              <span v-if="it.wdType === 1" v-katex
                                >${{ it.latex }}$</span
                              >
                              <img
                                v-else-if="it.wdType === 2"
                                :src="it.buffer"
                              />
                              <span class="tex2jax_ignore" v-else>{{
                                it.content
                              }}</span>
                            </span>
                          </span>
                        </div>
                      </div>
                    </template>
                    <el-empty v-else description="暂无题目内容"></el-empty>
                  </div>
                </div>

                <div class="ai-panel">
                  <div class="ai-panel-header">作答图片</div>
                  <div class="ai-panel-body ai-panel-upload">
                    <div class="ai-upload-actions">
                      <el-upload
                        ref="aiUpload"
                        class="ai-upload-control"
                        action="#"
                        :auto-upload="false"
                        :show-file-list="false"
                        accept=".jpg,.jpeg,.png,.webp,image/jpeg,image/png,image/webp"
                        :on-change="handleAiUploadChange"
                        :before-upload="beforeAiUpload"
                      >
                        <el-button size="small" type="primary">
                          {{ aiUploadFile ? "重新上传" : "选择作答图片" }}
                        </el-button>
                      </el-upload>
                      <el-button
                        size="small"
                        plain
                        :disabled="!aiUploadFile"
                        @click="clearAiUpload"
                        >清空</el-button
                      >
                    </div>
                    <p class="ai-upload-tip">仅支持 1 张图片，可重复替换。</p>
                    <div class="ai-upload-preview-box">
                      <div
                        v-if="aiUploadPreviewUrl"
                        class="ai-upload-preview-wrap"
                      >
                        <img
                          class="ai-upload-preview"
                          :src="aiUploadPreviewUrl"
                          alt="作答图片预览"
                        />
                      </div>
                      <div v-else class="ai-upload-placeholder">
                        <i class="el-icon-picture-outline"></i>
                        <p>请先上传作答图片</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="ai-panel">
                  <div class="ai-panel-header">AI分析与评价</div>
                  <div class="ai-panel-body ai-panel-result">
                    <div class="ai-result-card">
                      <div class="ai-result-row">
                        <span class="ai-result-label">分析状态</span>
                        <el-tag size="small" :type="aiResult.statusType">
                          {{ aiResult.status }}
                        </el-tag>
                      </div>
                    </div>

                    <div v-if="aiError" class="ai-result-error">
                      <h4>错误信息</h4>
                      <p>code: {{ aiError.code || "--" }}</p>
                      <p>message: {{ aiError.message || "请求失败" }}</p>
                    </div>

                    <div class="ai-result-section">
                      <h4>AI完整解析</h4>
                      <div
                        v-if="aiAnswerText"
                        v-katex
                        class="ai-text-block ai-latex-content"
                      >
                        {{ aiAnswerText }}
                      </div>
                      <el-empty
                        v-else
                        :image-size="56"
                        description="暂无解析结果"
                      ></el-empty>
                    </div>

                    <div class="ai-result-section">
                      <h4>OCR文本</h4>
                      <pre v-if="aiOcrText" class="ai-text-block">{{
                        aiOcrText
                      }}</pre>
                      <el-empty
                        v-else
                        :image-size="56"
                        description="暂无OCR文本"
                      ></el-empty>
                    </div>

                    <div v-if="aiSolving" class="ai-solving-tip">
                      正在调用AI接口，请稍候...
                    </div>
                  </div>
                </div>
              </div>
              <span slot="footer" class="dialog-footer">
                <el-button @click="closeAiDialog()">关闭</el-button>
                <el-button
                  type="primary"
                  :loading="aiSolving"
                  :disabled="!aiUploadFile || aiSolving"
                  @click="startAiAnalysis"
                  >开始AI解析</el-button
                >
              </span>
            </el-dialog>
            <el-dialog
              title="AI解析"
              :visible.sync="aiObjDialogVisible"
              width="88%"
              top="6vh"
              :close-on-click-modal="false"
              :before-close="closeAiObjDialog"
              class="ai-analysis-dialog ai-obj-dialog"
            >
              <div class="ai-obj-layout">
                <div class="ai-panel">
                  <div class="ai-panel-header">题目内容</div>
                  <div class="ai-panel-body ai-panel-question">
                    <template
                      v-if="
                        aiObjQuestion &&
                          aiObjQuestion.steam &&
                          aiObjQuestion.steam.length
                      "
                    >
                      <div
                        class="ai-qcontent"
                        v-for="(rginfos, i) in aiObjQuestion.steam"
                        :key="'aiobj-stem-' + i"
                      >
                        <span
                          v-for="(item, j) in rginfos.wordInfos"
                          :key="'aiobj-stem-item-' + i + '-' + j"
                        >
                          <span v-if="item.wdType === 1" name="imglatex" v-katex
                            >${{ item.latex }}$</span
                          >
                          <img
                            v-else-if="item.wdType === 2"
                            :src="item.buffer"
                          />
                          <span class="tex2jax_ignore" v-else>{{
                            item.content
                          }}</span>
                        </span>
                      </div>

                      <div
                        v-if="aiObjQuestion.hasjudge"
                        class="ai-options-block"
                      >
                        <p class="ai-block-title">选项</p>
                        <div class="ai-option-line">A. 正确</div>
                        <div class="ai-option-line">B. 错误</div>
                      </div>

                      <div v-if="aiObjQuestion.hasops" class="ai-options-block">
                        <p class="ai-block-title">选项</p>
                        <div
                          class="ai-option-line"
                          v-for="(item, index) in aiObjQuestion.options"
                          :key="'aiobj-option-' + index"
                        >
                          <span class="ai-option-label"
                            >{{
                              orderList[index]
                                ? orderList[index].label
                                : index + 1
                            }}.</span
                          >
                          <span
                            v-for="(t, i) in item.ranginfos || []"
                            :key="'aiobj-option-range-' + index + '-' + i"
                          >
                            <span
                              v-for="(it, j) in t.wordInfos || []"
                              :key="
                                'aiobj-option-word-' + index + '-' + i + '-' + j
                              "
                            >
                              <span v-if="it.wdType === 1" v-katex
                                >${{ it.latex }}$</span
                              >
                              <img
                                v-else-if="it.wdType === 2"
                                :src="it.buffer"
                              />
                              <span class="tex2jax_ignore" v-else>{{
                                it.content
                              }}</span>
                            </span>
                          </span>
                        </div>
                      </div>
                    </template>
                    <el-empty v-else description="暂无题目内容"></el-empty>
                  </div>
                </div>

                <div class="ai-panel">
                  <div class="ai-panel-header">AI解析内容</div>
                  <div class="ai-panel-body ai-panel-result">
                    <div v-if="aiObjError" class="ai-result-error">
                      <h4>错误信息</h4>
                      <p>code: {{ aiObjError.code || "--" }}</p>
                      <p>message: {{ aiObjError.message || "请求失败" }}</p>
                    </div>

                    <div
                      v-if="aiObjAnswerText"
                      class="ai-text-block ai-rich-content ai-latex-content"
                      v-katex="aiKatexOptions"
                      v-html="formatAiObjAnswerHtml(aiObjAnswerText)"
                    ></div>
                    <el-empty
                      v-else
                      :image-size="56"
                      description="暂无解析结果"
                    ></el-empty>
                  </div>
                </div>
                <div class="ai-panel">
                  <div class="ai-panel-header">举一反三</div>
                  <div class="ai-panel-body ai-panel-result">
                    <div v-if="aiObjExtendError" class="ai-result-error">
                      <h4>错误信息</h4>
                      <p>code: {{ aiObjExtendError.code || "--" }}</p>
                      <p>
                        message: {{ aiObjExtendError.message || "请求失败" }}
                      </p>
                    </div>
                    <div
                      v-if="aiObjExtendText"
                      class="ai-text-block ai-rich-content ai-latex-content"
                      v-katex="aiKatexOptions"
                      v-html="formatAiObjAnswerHtml(aiObjExtendText)"
                    ></div>
                    <div
                      v-else-if="aiObjExtendSolving"
                      class="ai-transfer-loading"
                    >
                      正在生成举一反三...
                    </div>
                    <el-empty
                      v-else
                      :image-size="56"
                      description="暂无举一反三内容"
                    ></el-empty>
                  </div>
                </div>
              </div>
              <span slot="footer" class="dialog-footer">
                <el-button @click="closeAiObjDialog()">关闭</el-button>
                <el-button
                  :loading="aiObjExtendSolving"
                  :disabled="
                    aiObjSolving || !aiObjAnswerText || aiObjExtendSolving
                  "
                  @click="handleAiObjExtension"
                  >举一反三</el-button
                >
                <el-button
                  type="primary"
                  :loading="aiObjSolving"
                  :disabled="aiObjSolving"
                  @click="startAiObjAnalysis"
                  >开始AI解析</el-button
                >
              </span>
            </el-dialog>
            <el-footer
              style="display: flex; justify-content: flex-end; padding: 15px 0 10px 0; height: auto; flex-shrink: 0;"
            >
              <el-pagination
                background
                :current-page.sync="currentPage"
                :page-sizes="[10, 20, 50]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next"
                @size-change="handleSizeChange"
                @current-change="on_clickPage"
                :total="totalcount"
              >
              </el-pagination>
            </el-footer>
          </el-main>
        </el-container>
      </el-container>
    </div>
  </div>
</template>
<script>
import qstem from "@/components/questionstem";
import {
  arrayBufferToBase64,
  base64ToByteArray,
  isEmpty
} from "@/util/extraction";
import {
  getchapters,
  getAllQuestion,
  getCollegeSubModules,
  getallcourses,
  getClassicQuestionKnowledgeTree,
  getClassicQuestionList
} from "@/api/course";
import {
  solveWithQuestion,
  solveObjectiveExtensionByDeepSeek,
  buildDeepSeekStreamUrl
} from "@/api/aiSolve";
import { savePracticeRecord } from "@/api/questionPractice";
import { getToken } from "@/util/session";
import { readRange, readjudgx, readoption } from "@/util/xmlreader";

const createDefaultAiResult = () => ({
  status: "待上传作答图片",
  statusType: "info"
});

export default {
  name: "question_lib",
  components: { qstem },
  props: {
    isClassic: {
      type: Boolean,
      default: false
    },
    fixedCourseSerialnumber: {
      type: String,
      default: ""
    },
    fixedCourseName: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      qsindex: Number,
      correct: false,
      submit: false,
      question: {},
      dialogVisible1: false,
      radio1: "",
      chapter: true,
      str: "\u3000",
      chaptersinfos: {},
      knowlegdes: {},
      knowlegdquestions: [],
      fliterlib: {},
      showmode: 1,
      orderList: [
        {
          value: 0,
          label: "A"
        },
        {
          value: 1,
          label: "B"
        },
        {
          value: 2,
          label: "C"
        },
        {
          value: 3,
          label: "D"
        },
        {
          value: 4,
          label: "E"
        },
        {
          value: 5,
          label: "F"
        },
        {
          value: 6,
          label: "G"
        },
        {
          value: 7,
          label: "H"
        },
        {
          value: 8,
          label: "I"
        }
      ],
      pageindex: 1,
      Xindex: 0,
      parsing: {},
      totalcount: 0,
      questionsels: [],
      questionffs: [],
      selquestion: {},
      selqtype: 7,
      radio: "",
      multx: [],
      dialogVisible: false,
      sellevel: "全部",
      currentPage: 1,
      pageSize: 10,
      coursesName: [],
      questypes: [
        { index: 0, lb: "判断题" },
        { index: 1, lb: "单选题" },
        { index: 2, lb: "多选题" },
        { index: 3, lb: "填空题" },
        { index: 4, lb: "解答题" },
        { index: 5, lb: "证明题" },
        { index: 6, lb: "综合题" },
        { index: 7, lb: "所有" }
      ],
      level: [
        { index: 0, lb: "易" },
        { index: 1, lb: "中" },
        { index: 2, lb: "难" },
        { index: 3, lb: "全部" }
      ],
      classicDifficultyOptions: [
        { index: 0, lb: "全部难度", value: "" },
        { index: 1, lb: "难度 1（入门）", value: 1 },
        { index: 2, lb: "难度 2（初级）", value: 2 },
        { index: 3, lb: "难度 3（中等）", value: 3 },
        { index: 4, lb: "难度 4（较难）", value: 4 },
        { index: 5, lb: "难度 5（挑战）", value: 5 }
      ],
      piecolors: { 1: "#67C23A", 2: "#E6A23C", 3: "#F56C6C" },
      lockscreen: false,
      activeKnowledgeSerialnumber: "",
      questionViewStartAt: 0,
      practiceStats: {
        questionTotal: 0,
        answeredTotal: 0,
        correctTotal: 0,
        completionRate: "0.00"
      },
      practiceAnsweredMap: {},
      practiceLastQuestionIndex: null,
      practicePendingQueue: [],
      practiceFlushing: false,
      practiceAutosaveTimer: null,
      practiceSyncFailed: false,
      aiDialogVisible: false,
      aiQuestion: {},
      aiUploadFile: null,
      aiUploadPreviewUrl: "",
      aiResult: createDefaultAiResult(),
      aiSolving: false,
      aiRequestId: "",
      aiLatencyMs: null,
      aiOcrText: "",
      aiAnswerText: "",
      aiError: null,
      aiSolveRequestSeq: 0,
      aiObjDialogVisible: false,
      aiObjQuestion: {},
      aiObjResult: { status: "待解析", statusType: "info" },
      aiObjSolving: false,
      aiObjRequestId: "",
      aiObjLatencyMs: null,
      aiObjAnswerText: "",
      aiObjError: null,
      aiObjExtendText: "",
      aiObjExtendError: null,
      aiObjExtendSolving: false,
      aiObjSolveRequestSeq: 0,
      aiKatexOptions: {
        delimiters: [
          { left: "$$", right: "$$", display: true },
          { left: "$", right: "$", display: false },
          { left: "\\(", right: "\\)", display: false },
          { left: "\\[", right: "\\]", display: true }
        ],
        throwOnError: false,
        strict: "ignore"
      },
      aiObjEventSource: null,
      aiObjStreamManualClose: false,
      aiObjStreamHasToken: false,
      aiObjStreamStartedAt: 0
    };
  },
  computed: {
    siderTitle() {
      if (this.isClassic) {
        return "经典题知识点";
      }
      if (this.fixedCourseSerialnumber) {
        return this.fixedCourseName ? `${this.fixedCourseName}知识点` : "课程知识点";
      }
      return "课程";
    },
    hasKnowledgeQuestion() {
      return this.knowlegdquestions.length > 0;
    },
    practiceCorrectRate() {
      const answered = Number(this.practiceStats.answeredTotal || 0);
      if (!answered) {
        return "0.00";
      }
      const correct = Number(this.practiceStats.correctTotal || 0);
      return ((correct * 100) / answered).toFixed(2);
    },
    bg() {
      return {
        backgroundRepeat: "repeat",
        backgroundSize: "128px 64px"
      };
    },
    isSubject() {
      const qtype = this.question.qtype;
      if (qtype) {
        if (
          qtype === "填空题" ||
          qtype === "解答题" ||
          qtype === "证明题" ||
          qtype === "综合题"
        ) {
          return true;
        }
      }
      return false;
    }
  },
  async mounted() {
    if (this.isClassic) {
      this.sellevel = 0;
      await this.initClassicMode();
    } else if (this.fixedCourseSerialnumber) {
      this.radio1 = this.fixedCourseSerialnumber;
      await this.initFixedCourseMode();
    } else {
      let coursesNum = [];
      const userInfoStr = localStorage.getItem("userInfo");
      let colledgeId = userInfoStr ? JSON.parse(userInfoStr).collegeId : null;
      if (colledgeId) {
        const subres = await getCollegeSubModules(colledgeId);
        coursesNum = subres.data || [];
        const getres = await getallcourses();
        if (getres && getres.data) {
          coursesNum.forEach(val => {
            let courseitems = getres.data.filter(item => {
              return item.serialnumber == val;
            });
            if (courseitems.length > 0) {
              const courseitem = courseitems[0];
              this.coursesName.push(courseitem);
            }
          });
        }
      }
    }
    //渲染
    window.addEventListener("beforeunload", this.onBeforeUnload);
    this.practiceAutosaveTimer = setInterval(() => {
      this.flushPracticeQueue();
    }, 5000);
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.onBeforeUnload);
    if (this.practiceAutosaveTimer) {
      clearInterval(this.practiceAutosaveTimer);
      this.practiceAutosaveTimer = null;
    }
    this.closeAiObjStream();
    this.resetAiDialogState();
    this.resetAiObjDialogState();
    this.saveDraftQueue();
  },
  methods: {
    getCellIndex: function({ row, rowIndex }) {
      row.index = rowIndex;
      if (row && row.questionId && row.practiced) {
        return "answered-row";
      }
      return "";
    },
    async last() {
      this.disableDialogVisible();
      this.question = {};
      if (this.currentPage == 1 && this.qsindex == 0) {
        this.$message({
          message: "已是第一题",
          type: "warning"
        });
      } else {
        this.qsindex--;
        if (this.questionsels[this.qsindex] == undefined) {
          this.currentPage--;
          this.pageindex--;
          await this.on_clickPage(this.pageindex);
          this.qsindex = 9;
          this.$nextTick(() => {
            this.question = this.questionsels[this.qsindex];
            this.questionViewStartAt = Date.now();
          });
          this.radio = "";
        } else {
          this.question = {};
          this.$nextTick(() => {
            this.question = this.questionsels[this.qsindex];
            this.questionViewStartAt = Date.now();
          });
          this.correct = false;
          this.radio = "";
        }
        this.submit = false;
        this.$forceUpdate();
        this.Xindex += 1;
      }
    },
    //检查答案
    async checkAnswer() {
      let hasAnswer = false;
      let isCorrect = null;
      switch (this.question.qtype) {
        case "单选题": {
          const radsgx = this.question.radio;
          if (radsgx) {
            const radfd = this.orderList.find(x => x.label === radsgx);
            if (radfd) {
              const option = this.question.options[radfd.value];
              isCorrect = !!(option && option.correct);
              if (isCorrect) {
                this.$message.success("您的答案正确！");
              } else {
                this.$message.error("您的答案错了！");
              }
            }
            hasAnswer = true;
          } else {
            this.$message.error("您未选择答案！");
          }
          break;
        }
        case "判断题": {
          if (
            this.question.radio === "" ||
            this.question.radio === null ||
            typeof this.question.radio === "undefined"
          ) {
            this.$message.error("您未选择答案！");
            break;
          }
          const radsgx = this.question.radio === 1 ? "正确" : "错误";
          isCorrect = this.question.judge === radsgx;
          if (isCorrect) {
            this.$message.success("您的答案正确！");
          } else {
            this.$message.error("您的答案错了！");
          }
          hasAnswer = true;
          break;
        }
        case "多选题": {
          if (this.question.multx.length > 0) {
            const rganswer = [...this.question.multx].sort();
            let rranswer = [];
            this.question.options.forEach((qitem, index) => {
              if (qitem.correct) {
                rranswer.push(this.orderList[index].label);
              }
            });
            rranswer = rranswer.sort();
            let iscrr = true;
            if (rganswer.length === rranswer.length) {
              const rrcount = rganswer.length;
              for (let ii = 0; ii < rrcount; ii++) {
                iscrr = iscrr && rganswer[ii] === rranswer[ii];
              }
            } else {
              iscrr = false;
            }
            if (iscrr) {
              this.$message.success("您的答案正确！");
            } else {
              this.$message.error("您的答案错了！");
            }
            isCorrect = iscrr;
            hasAnswer = true;
          } else {
            this.$message.error("未选择答案！");
          }
          break;
        }
        default:
          break;
      }
      if (hasAnswer) {
        this.submit = true;
        await this.saveCurrentQuestionProgress(isCorrect);
      }
    },
    async next() {
      this.disableDialogVisible();
      if (this.currentPage == this.totalcount) {
        this.$message({
          message: "已是最后一页",
          type: "warning"
        });
      } else {
        this.qsindex++;
        if (this.questionsels[this.qsindex] == undefined) {
          this.pageindex++;
          await this.on_clickPage(this.pageindex);
          this.currentPage++;
          this.qsindex = 0;
          this.$nextTick(() => {
            this.question = this.questionsels[this.qsindex];
            this.questionViewStartAt = Date.now();
          });
          this.radio = "";
          this.$forceUpdate();
        } else {
          this.question = {};
          this.$nextTick(() => {
            this.question = this.questionsels[this.qsindex];
            this.questionViewStartAt = Date.now();
          });
          this.correct = false;
          this.radio = "";
        }
        this.$forceUpdate();
        this.Xindex += 1;
        this.submit = false;
      }
    },
    sshow(row) {
      this.qsindex = row.index;
      this.question = this.questionsels[this.qsindex];
      this.questionViewStartAt = Date.now();
      this.dialogVisible1 = true;
      this.submit = false;
    },
    openAiDialog(row) {
      this.resetAiDialogState();
      this.aiQuestion = row ? { ...row } : {};
      this.aiDialogVisible = true;
    },
    closeAiDialog(done) {
      this.aiDialogVisible = false;
      this.aiSolveRequestSeq += 1;
      this.resetAiDialogState();
      if (typeof done === "function") {
        done();
      }
    },
    beforeAiUpload(file) {
      const fileType = ((file && file.type) || "").toLowerCase();
      const allowedMimeTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/webp"
      ];
      const ext = ((file && file.name) || "")
        .split(".")
        .pop()
        .toLowerCase();
      const allowedExt = ["jpg", "jpeg", "png", "webp"];
      const isImage =
        allowedMimeTypes.includes(fileType) || allowedExt.includes(ext);
      if (!isImage) {
        this.$message.error("仅支持 jpg/jpeg/png/webp 图片格式");
        return false;
      }
      const isLt20M = file.size / 1024 / 1024 <= 20;
      if (!isLt20M) {
        this.$message.error("图片大小不能超过 20MB");
        return false;
      }
      return true;
    },
    handleAiUploadChange(file) {
      const rawFile = file && file.raw ? file.raw : file;
      if (!rawFile || !this.beforeAiUpload(rawFile)) {
        if (this.$refs.aiUpload) {
          this.$refs.aiUpload.clearFiles();
        }
        return;
      }
      if (this.aiUploadPreviewUrl) {
        URL.revokeObjectURL(this.aiUploadPreviewUrl);
      }
      this.aiUploadFile = rawFile;
      this.aiUploadPreviewUrl = URL.createObjectURL(rawFile);
      this.aiResult = {
        status: "待AI解析",
        statusType: "warning"
      };
      this.aiError = null;
      if (this.$refs.aiUpload) {
        this.$refs.aiUpload.clearFiles();
      }
    },
    clearAiUpload() {
      if (this.aiUploadPreviewUrl) {
        URL.revokeObjectURL(this.aiUploadPreviewUrl);
      }
      this.aiUploadPreviewUrl = "";
      this.aiUploadFile = null;
      this.aiResult = createDefaultAiResult();
      this.aiRequestId = "";
      this.aiLatencyMs = null;
      this.aiOcrText = "";
      this.aiAnswerText = "";
      this.aiError = null;
      if (this.$refs.aiUpload) {
        this.$refs.aiUpload.clearFiles();
      }
    },
    resetAiDialogState() {
      if (this.aiUploadPreviewUrl) {
        URL.revokeObjectURL(this.aiUploadPreviewUrl);
      }
      this.aiUploadPreviewUrl = "";
      this.aiUploadFile = null;
      this.aiQuestion = {};
      this.aiResult = createDefaultAiResult();
      this.aiSolving = false;
      this.aiRequestId = "";
      this.aiLatencyMs = null;
      this.aiOcrText = "";
      this.aiAnswerText = "";
      this.aiError = null;
      if (this.$refs.aiUpload) {
        this.$refs.aiUpload.clearFiles();
      }
    },
    extractRichTextToPlain(ranges) {
      if (!Array.isArray(ranges)) {
        return "";
      }
      const lines = ranges
        .map(rangeInfo => {
          const words = Array.isArray(rangeInfo.wordInfos)
            ? rangeInfo.wordInfos
            : [];
          return words
            .map(word => {
              if (word.wdType === 1) {
                return word.latex ? `$${word.latex}$` : "";
              }
              if (word.wdType === 2) {
                return "[图片]";
              }
              return word.content || "";
            })
            .join("");
        })
        .map(x => x.trim())
        .filter(Boolean);
      return lines.join("\n");
    },
    escapeHtml(rawText) {
      return String(rawText || "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
    },
    formatAiObjAnswerHtml(rawText) {
      if (!rawText) {
        return "";
      }
      const normalized = this.normalizeAiLatexForRender(String(rawText))
        .replace(/\r\n/g, "\n")
        .replace(/\\n/g, "\n");
      const withSectionBreak = normalized
        .replace(/\s*(\d+\.\s*\*\*)/g, "\n$1")
        .replace(/\s*([A-H][\.、]\s*\*\*)/g, "\n$1")
        .replace(/\s*(-\s*\*\*)/g, "\n$1");
      const escaped = this.escapeHtml(withSectionBreak);
      const lines = escaped
        .split("\n")
        .map(line => line.trim())
        .filter(Boolean);
      if (!lines.length) {
        return "";
      }
      return lines
        .map(line => {
          const withBold = line.replace(
            /\*\*(.+?)\*\*/g,
            "<strong>$1</strong>"
          );
          if (/^\d+\./.test(withBold)) {
            return `<p class="ai-rich-line ai-rich-section">${withBold}</p>`;
          }
          if (/^[A-H][\.、]/.test(withBold)) {
            return `<p class="ai-rich-line ai-rich-option">${withBold}</p>`;
          }
          if (/^-\s+/.test(withBold)) {
            return `<p class="ai-rich-line ai-rich-bullet">${withBold}</p>`;
          }
          return `<p class="ai-rich-line">${withBold}</p>`;
        })
        .join("");
    },
    normalizeAiLatexForRender(text) {
      if (!text) {
        return "";
      }
      // 修复 AI 常见输出：\cosx、\sinx、\tanx 等会被 KaTeX 识别为未知命令
      // 统一改成 \cos x 这类可解析形式
      return String(text).replace(
        /\\(sin|cos|tan|cot|sec|csc|ln|log|exp|sqrt)(?=[A-Za-z0-9])/g,
        "\\$1 "
      );
    },
    buildAiQuestionText(question) {
      if (!question) {
        return "";
      }
      const typeText = question.qtype || "未知题型";
      const stemText = this.extractRichTextToPlain(question.steam || []);
      const lines = [
        `【题型】${typeText}`,
        "【题目】",
        stemText || "（题目为空）"
      ];
      if (question.hasjudge) {
        lines.push("【选项】", "A. 正确", "B. 错误");
      } else if (question.hasops && Array.isArray(question.options)) {
        lines.push("【选项】");
        question.options.forEach((opt, index) => {
          const label = this.orderList[index]
            ? this.orderList[index].label
            : `${index + 1}`;
          const optionText = this.extractRichTextToPlain(opt.ranginfos || []);
          lines.push(`${label}. ${optionText || "（空）"}`);
        });
      }
      return lines.join("\n").trim();
    },
    applyAiSuccess(payload, requestSeq) {
      if (requestSeq !== this.aiSolveRequestSeq) {
        return;
      }
      this.aiRequestId = payload.requestId || "";
      this.aiLatencyMs =
        typeof payload.latencyMs === "number" ? payload.latencyMs : null;
      this.aiOcrText =
        (payload.data && payload.data.ocr && payload.data.ocr.ocrText) || "";
      this.aiAnswerText =
        (payload.data && payload.data.solve && payload.data.solve.answerText) ||
        "";
      this.aiError = null;
      this.aiResult = {
        status: "解析成功",
        statusType: "success"
      };
    },
    applyAiError(error, requestSeq) {
      if (requestSeq !== this.aiSolveRequestSeq) {
        return;
      }
      const responseData =
        (error && error.response && error.response.data) || error || {};
      const normalizedError = responseData.error || {};
      const hasHttpResponse = !!(error && error.response);
      this.aiRequestId = responseData.requestId || this.aiRequestId;
      this.aiLatencyMs =
        typeof responseData.latencyMs === "number"
          ? responseData.latencyMs
          : this.aiLatencyMs;
      this.aiError = {
        code: normalizedError.code || "NETWORK_ERROR",
        message:
          normalizedError.message ||
          (hasHttpResponse
            ? error.message
            : `网络或跨域错误，请检查 /api/ai/test/subjective/solve（${error.message ||
                "no-response"}）`)
      };
      this.aiResult = {
        status: "解析失败",
        statusType: "danger"
      };
      this.aiAnswerText = "";
      this.aiOcrText = "";
    },
    async startAiAnalysis() {
      if (this.aiSolving) {
        return;
      }
      if (!this.aiUploadFile) {
        this.$message.warning("请先上传作答图片");
        return;
      }
      const questionText = this.buildAiQuestionText(this.aiQuestion);
      if (!questionText) {
        this.$message.warning("题目内容为空，无法发起解析");
        return;
      }
      this.aiSolveRequestSeq += 1;
      const requestSeq = this.aiSolveRequestSeq;
      this.aiSolving = true;
      this.aiError = null;
      this.aiResult = {
        status: "解析中...",
        statusType: "warning"
      };
      try {
        const payload = await solveWithQuestion({
          question: questionText,
          file: this.aiUploadFile
        });
        if (!payload || payload.success !== true) {
          this.applyAiError(payload || new Error("AI响应异常"), requestSeq);
          return;
        }
        this.applyAiSuccess(payload, requestSeq);
      } catch (error) {
        this.applyAiError(error, requestSeq);
      } finally {
        if (requestSeq === this.aiSolveRequestSeq) {
          this.aiSolving = false;
        }
      }
    },
    openAiObjDialog(row) {
      this.resetAiObjDialogState();
      this.aiObjQuestion = row ? { ...row } : {};
      this.aiObjDialogVisible = true;
    },
    closeAiObjDialog(done) {
      this.aiObjDialogVisible = false;
      this.aiObjSolveRequestSeq += 1;
      this.resetAiObjDialogState();
      if (typeof done === "function") {
        done();
      }
    },
    closeAiObjStream() {
      if (this.aiObjEventSource) {
        this.aiObjStreamManualClose = true;
        this.aiObjEventSource.close();
        this.aiObjEventSource = null;
      }
    },
    resetAiObjDialogState() {
      this.closeAiObjStream();
      this.aiObjQuestion = {};
      this.aiObjResult = { status: "待解析", statusType: "info" };
      this.aiObjSolving = false;
      this.aiObjRequestId = "";
      this.aiObjLatencyMs = null;
      this.aiObjAnswerText = "";
      this.aiObjError = null;
      this.aiObjExtendText = "";
      this.aiObjExtendError = null;
      this.aiObjExtendSolving = false;
      this.aiObjStreamManualClose = false;
      this.aiObjStreamHasToken = false;
      this.aiObjStreamStartedAt = 0;
    },
    async startAiObjExtension(requestSeq, questionText, analysisText) {
      if (requestSeq !== this.aiObjSolveRequestSeq) {
        return;
      }
      this.aiObjExtendSolving = true;
      this.aiObjExtendError = null;
      this.aiObjExtendText = "";
      try {
        const payload = await solveObjectiveExtensionByDeepSeek({
          questionText,
          analysisText
        });
        if (requestSeq !== this.aiObjSolveRequestSeq) {
          return;
        }
        if (!payload || payload.success !== true) {
          this.aiObjExtendError = {
            code: (payload && payload.code) || "UNKNOWN",
            message: (payload && payload.message) || "举一反三生成失败"
          };
          return;
        }
        this.aiObjExtendText = (payload.data && payload.data.content) || "";
        if (!this.aiObjExtendText) {
          this.aiObjExtendError = {
            code: "EMPTY_RESULT",
            message: "举一反三返回为空"
          };
        }
      } catch (error) {
        if (requestSeq !== this.aiObjSolveRequestSeq) {
          return;
        }
        const responseData =
          (error && error.response && error.response.data) || {};
        this.aiObjExtendError = {
          code: responseData.code || "NETWORK_ERROR",
          message:
            responseData.message ||
            `举一反三生成失败（${(error && error.message) || "no-response"}）`
        };
      } finally {
        if (requestSeq === this.aiObjSolveRequestSeq) {
          this.aiObjExtendSolving = false;
        }
      }
    },
    handleAiObjExtension() {
      if (this.aiObjSolving) {
        this.$message.warning("请先等待AI解析完成");
        return;
      }
      if (!this.aiObjAnswerText) {
        this.$message.warning("请先完成AI解析");
        return;
      }
      const questionText = this.buildAiQuestionText(this.aiObjQuestion);
      if (!questionText) {
        this.$message.warning("题目内容为空，无法生成举一反三");
        return;
      }
      const requestSeq = this.aiObjSolveRequestSeq;
      this.startAiObjExtension(requestSeq, questionText, this.aiObjAnswerText);
    },
    startAiObjAnalysis() {
      const questionText = this.buildAiQuestionText(this.aiObjQuestion);
      if (!questionText) {
        this.$message.warning("题目内容为空，无法发起解析");
        return;
      }
      this.aiObjSolveRequestSeq += 1;
      const requestSeq = this.aiObjSolveRequestSeq;
      this.closeAiObjStream();
      this.aiObjSolving = true;
      this.aiObjError = null;
      this.aiObjRequestId = "";
      this.aiObjLatencyMs = null;
      this.aiObjAnswerText = "";
      this.aiObjStreamHasToken = false;
      this.aiObjStreamManualClose = false;
      this.aiObjStreamStartedAt = Date.now();
      this.aiObjExtendText = "";
      this.aiObjExtendError = null;
      this.aiObjExtendSolving = false;
      this.aiObjResult = {
        status: "解析中...",
        statusType: "warning"
      };
      if (typeof EventSource === "undefined") {
        this.aiObjSolving = false;
        this.aiObjResult = { status: "解析失败", statusType: "danger" };
        this.aiObjError = {
          code: "EVENTSOURCE_UNSUPPORTED",
          message: "当前浏览器不支持流式解析（EventSource）"
        };
        return;
      }
      const streamUrl = buildDeepSeekStreamUrl(questionText);
      const source = new EventSource(streamUrl);
      this.aiObjEventSource = source;
      source.onmessage = event => {
        if (requestSeq !== this.aiObjSolveRequestSeq) {
          return;
        }
        const token = (event && event.data) || "";
        if (!token) {
          return;
        }
        this.aiObjStreamHasToken = true;
        this.aiObjAnswerText += token;
      };
      source.onerror = () => {
        if (requestSeq !== this.aiObjSolveRequestSeq) {
          source.close();
          return;
        }
        const wasManualClose = this.aiObjStreamManualClose;
        const hasToken = this.aiObjStreamHasToken;
        source.close();
        if (this.aiObjEventSource === source) {
          this.aiObjEventSource = null;
        }
        if (wasManualClose) {
          this.aiObjSolving = false;
          this.aiObjStreamManualClose = false;
          this.aiObjStreamHasToken = false;
          this.aiObjStreamStartedAt = 0;
          return;
        }
        this.aiObjLatencyMs = this.aiObjStreamStartedAt
          ? Date.now() - this.aiObjStreamStartedAt
          : null;
        if (hasToken) {
          this.aiObjError = null;
          this.aiObjResult = { status: "解析成功", statusType: "success" };
        } else {
          this.aiObjError = {
            code: "STREAM_ERROR",
            message:
              "系统AI流式接口请求失败，请检查 /api/ai/test/objective/stream"
          };
          this.aiObjResult = { status: "解析失败", statusType: "danger" };
          if (!hasToken) {
            this.aiObjAnswerText = "";
          }
        }
        this.aiObjSolving = false;
        this.aiObjStreamManualClose = false;
        this.aiObjStreamHasToken = false;
        this.aiObjStreamStartedAt = 0;
      };
    },
    async onClickcourses() {
      await this.flushPracticeQueue(true);
      this.resetPracticeState();
      await getchapters(this.radio1)
        .then(res => {
          this.chaptersinfos = res.data;
          this.chapter = !this.chapter;
          this.$forceUpdate();
        })
        .catch(err => {
          console.err(err);
        });
    },
    textNum(index) {
      if (index == 0) {
        return "一、";
      } else if (index == 1) {
        return "二、";
      } else if (index == 2) {
        return "三、";
      } else if (index == 3) {
        return "四、";
      } else if (index == 4) {
        return "五、";
      } else if (index == 5) {
        return "六、";
      } else if (index == 6) {
        return "七、";
      } else if (index == 7) {
        return "八、";
      } else if (index == 8) {
        return "九、";
      } else if (index == 9) {
        return "十、";
      } else if (index == 10) {
        return "十一、";
      } else if (index == 11) {
        return "十二、";
      } else if (index == 12) {
        return "十三、";
      } else if (index == 13) {
        return "十四、";
      } else if (index == 14) {
        return "十五、";
      } else if (index == 15) {
        return "十六、";
      } else if (index == 16) {
        return "十七、";
      }
    },
    handleClose() {
      this.disableDialogVisible();
      this.dialogVisible1 = false;
    },
    getLevelText(level) {
      if (level === 1 || level === "1") return "易";
      if (level === 2 || level === "2") return "中";
      if (level === 3 || level === "3") return "难";
      return level;
    },
    getQuestionType() {
      switch (this.selqtype) {
        case 0:
          return "JudgX";
        case 1:
          return "SingX";
        case 2:
          return "MultX";
        case 3:
          return "FillX";
        case 4:
          return "AnwsX";
        case 5:
          return "ProofX";
        case 6:
          return "Zgzh";
        default:
          return "All";
      }
    },
    getQuestionLevel() {
      switch (this.sellevel) {
        case 0:
          return "1";
        case 1:
          return "2";
        case 2:
          return "3";
        case 3:
          return "All";
      }
    },
    getDifficultyTagType(level) {
      const map = { 1: "success", 2: "", 3: "warning", 4: "danger", 5: "danger" };
      return map[level] || "info";
    },
    async initFixedCourseMode() {
      this.lockscreen = true;
      try {
        const res = await getchapters(this.fixedCourseSerialnumber);
        if (res && res.data && res.data.length > 0) {
          this.chaptersinfos = res.data;
          this.chapter = false;
          let targetSn = "";
          for (const chap of this.chaptersinfos) {
            if (chap.knowledges && chap.knowledges.length) {
              targetSn = chap.knowledges[0].serialnumber;
              break;
            }
          }
          if (targetSn) {
            await this.onClickKnowledgeItem(targetSn);
          }
        } else {
          this.chaptersinfos = [];
          this.chapter = false;
        }
      } catch (err) {
        console.error("初始化专科微积分知识点失败", err);
      } finally {
        this.lockscreen = false;
      }
    },
    async initClassicMode() {
      this.lockscreen = true;
      try {
        const res = await getClassicQuestionKnowledgeTree();
        if (res && res.data && res.data.length > 0) {
          this.chaptersinfos = res.data;
          this.chapter = false;
          let targetSn = "";
          for (const chap of this.chaptersinfos) {
            if (chap.knowledges && chap.knowledges.length) {
              const withQ = chap.knowledges.find(k => k.questionCount > 0);
              if (withQ) {
                targetSn = withQ.serialnumber || withQ.code;
                break;
              }
              if (!targetSn) {
                targetSn = chap.knowledges[0].serialnumber || chap.knowledges[0].code;
              }
            }
          }
          if (targetSn) {
            await this.onClickKnowledgeItem(targetSn);
          }
        } else {
          this.chaptersinfos = [];
          this.chapter = false;
        }
      } catch (err) {
        console.error("初始化经典题知识点失败", err);
      } finally {
        this.lockscreen = false;
      }
    },
    applyFilters() {
      if (!this.knowlegdquestions || this.knowlegdquestions.length === 0) {
        this.fliterlib = [];
        this.totalcount = 0;
        this.getFilterQuestions();
        this.forceupdate();
        return;
      }
      const qtype = this.getQuestionType();
      this.fliterlib = this.knowlegdquestions.filter(x => {
        let typeMatch = true;
        if (qtype !== "All") {
          typeMatch = x.qtype === qtype;
        }

        let levelMatch = true;
        if (this.isClassic) {
          if (this.sellevel !== 0 && this.sellevel !== "全部") {
            const itemDiff = Number(x.difficultyLevel || x.level);
            levelMatch = itemDiff === Number(this.sellevel);
          }
        } else {
          if (this.sellevel !== 3 && this.sellevel !== "全部") {
            levelMatch = String(x.level) === String(this.getQuestionLevel());
          }
        }
        return typeMatch && levelMatch;
      });
      this.totalcount = this.fliterlib.length;
      this.currentPage = 1;
      this.pageindex = 1;
      this.getFilterQuestions();
      this.forceupdate();
    },
    onfilterQtype(selqtype) {
      this.selqtype = selqtype;
      this.applyFilters();
    },
    onfilterLevel(sellevel) {
      this.sellevel = sellevel;
      this.applyFilters();
    },
    onSetChapters(schapters) {
      this.chapters = schapters.datas;
    },
    opendialogVisible() {
      this.question.hasslove = true;
      this.correct = true;
      this.Xindex += 1;
      this.$forceUpdate();
    },
    disableDialogVisible() {
      if (this.question) {
        this.question.hasslove = false;
        switch (this.question.qtype) {
          case "单选题": {
            this.question.radio = "";
            break;
          }
          case "判断题": {
            this.question.radio = "";
            break;
          }
          case "多选题": {
            this.question.multx = [];
            break;
          }
          default:
            break;
        }
      }
      this.correct = false;
      this.question = {};
    },
    onSetChapters_error() {},
    //加载题目
    loadquestion(tmpquestion) {
      let ntmp = {};
      ntmp.questionId = tmpquestion.id;
      ntmp.questionOrder = tmpquestion.practiceOrder || 0;
      ntmp.practiced = !!tmpquestion.practiced;
      ntmp.qtypeCode = tmpquestion.qtype;
      ntmp.id = tmpquestion.id;
      ntmp.level = tmpquestion.level;
      ntmp.difficultyLevel = tmpquestion.difficultyLevel || null;
      ntmp.vocationalKnowledgeCode = tmpquestion.vocationalKnowledgeCode || "";
      ntmp.vocationalKnowledgeName = tmpquestion.vocationalKnowledgeName || "";
      ntmp.vocationalChapterName = tmpquestion.vocationalChapterName || "";
      ntmp.courseSerialnumber = tmpquestion.courseSerialnumber || "";
      ntmp.serialnumber = tmpquestion.knowledgeSerialnumber + tmpquestion.qID;
      if (isEmpty(tmpquestion.steamjs)) {
        ntmp.steam = readRange(tmpquestion.steam);
      } else {
        ntmp.steam = JSON.parse(tmpquestion.steamjs);
      }

      for (let index = 0; index < ntmp.steam.length; index++) {
        let raginfo = ntmp.steam[index];
        for (let wdindex = 0; wdindex < raginfo.wordInfos.length; wdindex++) {
          let rag = raginfo.wordInfos[wdindex];

          if (rag.wdType === 1 && rag.haslatex === false) {
            rag.wdType = 2;
            rag.buffer = arrayBufferToBase64(
              tmpquestion.steambuffer,
              rag.imgstartpos,
              rag.imgstartpos + rag.imglen
            );
            raginfo.wordInfos[wdindex] = rag;
          }
        }
      }
      ntmp.slove = [];
      ntmp.fill = [];
      ntmp.options = [];

      ntmp.hasslove = false;

      // ntmp.hasslove = true;
      if (isEmpty(tmpquestion.solvejs)) {
        ntmp.slove = readRange(tmpquestion.slove);
      } else {
        ntmp.slove = JSON.parse(tmpquestion.solvejs);
      }

      for (let index = 0; index < ntmp.slove.length; index++) {
        let raginfo = ntmp.slove[index];
        for (let wdindex = 0; wdindex < raginfo.wordInfos.length; wdindex++) {
          let rag = raginfo.wordInfos[wdindex];
          if (rag.wdType === 1 && rag.haslatex === false) {
            rag.wdType = 2;
            rag.buffer = arrayBufferToBase64(
              tmpquestion.solvebuffer,
              rag.imgstartpos,
              rag.imgstartpos + rag.imglen
            );
            raginfo.wordInfos[wdindex] = rag;
          }
        }
      }

      ntmp.qtype = "未知";
      ntmp.hasjudge = false;
      if (tmpquestion.qtype === "JudgX") {
        ntmp.qtype = "判断题";
        ntmp.hasjudge = true;
        ntmp.radio = "";
        if (isEmpty(tmpquestion.answerjs)) {
          let jgbr = readjudgx(tmpquestion.answer);
          if (jgbr) {
            ntmp.judge = "正确";
          } else {
            ntmp.judge = "错误";
          }
        } else {
          let jgx = JSON.parse(tmpquestion.answerjs);
          if (jgx.judge) {
            ntmp.judge = "正确";
          } else {
            ntmp.judge = "错误";
          }
        }
      }
      ntmp.hasops = false;
      if (tmpquestion.qtype === "SingX") {
        ntmp.qtype = "单选题";
        ntmp.radio = "";
        ntmp.hasops = true;
        if (isEmpty(tmpquestion.answerjs)) {
          ntmp.options = readoption(tmpquestion.answer);
        } else {
          ntmp.options = JSON.parse(tmpquestion.answerjs);
        }

        for (let index = 0; index < ntmp.options.length; index++) {
          let opitem = ntmp.options[index];
          for (let i = 0; i < opitem.ranginfos.length; i++) {
            let raginfo = opitem.ranginfos[i];
            for (
              let wdindex = 0;
              wdindex < raginfo.wordInfos.length;
              wdindex++
            ) {
              let rag = raginfo.wordInfos[wdindex];
              if (rag.wdType === 1 && rag.haslatex === false) {
                rag.wdType = 2;
                rag.buffer = arrayBufferToBase64(
                  tmpquestion.answerbuffer,
                  rag.imgstartpos,
                  rag.imgstartpos + rag.imglen
                );
                raginfo.wordInfos[wdindex] = rag;
              }
            }
          }
          // console.log(opitem)
          // ntmp.options[index] = opitem;
          // console.log(ntmp)
        }
      }
      if (tmpquestion.qtype === "MultX") {
        ntmp.qtype = "多选题";
        ntmp.multx = [];
        ntmp.hasops = true;
        if (isEmpty(tmpquestion.answerjs)) {
          ntmp.options = readoption(tmpquestion.answer);
        } else {
          ntmp.options = JSON.parse(tmpquestion.answerjs);
        }
        for (let index = 0; index < ntmp.options.length; index++) {
          let opitem = ntmp.options[index];
          for (let i = 0; i < opitem.ranginfos.length; i++) {
            let raginfo = opitem.ranginfos[i];
            for (
              let wdindex = 0;
              wdindex < raginfo.wordInfos.length;
              wdindex++
            ) {
              let rag = raginfo.wordInfos[wdindex];
              if (rag.wdType === 1) {
                let rag = raginfo.wordInfos[wdindex];
                if (rag.wdType === 1 && rag.haslatex === false) {
                  rag.wdType = 2;
                  rag.buffer = arrayBufferToBase64(
                    tmpquestion.answerbuffer,
                    rag.imgstartpos,
                    rag.imgstartpos + rag.imglen
                  );
                  raginfo.wordInfos[wdindex] = rag;
                }
                raginfo.wordInfos[wdindex] = rag;
              }
            }
          }
          ntmp.options[index] = opitem;
        }
      }
      ntmp.hasfill = false;
      if (tmpquestion.qtype === "FillX") {
        ntmp.qtype = "填空题";
        ntmp.hasfill = true;
        if (isEmpty(tmpquestion.answerjs)) {
          ntmp.fill = readRange(tmpquestion.answer);
        } else {
          ntmp.fill = JSON.parse(tmpquestion.answerjs);
        }
        for (let index = 0; index < ntmp.fill.length; index++) {
          let raginfo = ntmp.fill[index];
          for (let wdindex = 0; wdindex < raginfo.wordInfos.length; wdindex++) {
            let rag = raginfo.wordInfos[wdindex];
            if (rag.wdType === 1 && rag.haslatex === false) {
              rag.wdType = 2;
              rag.buffer = arrayBufferToBase64(
                tmpquestion.answerbuffer,
                rag.imgstartpos,
                rag.imgstartpos + rag.imglen
              );
              raginfo.wordInfos[wdindex] = rag;
            }
          }
        }
      }
      if (tmpquestion.qtype === "AnwsX") {
        ntmp.qtype = "解答题";
      }
      if (tmpquestion.qtype === "ProofX") {
        ntmp.qtype = "证明题";
      }
      if (tmpquestion.qtype === "All") {
        ntmp.qtype = "全题型";
      }
      //ntmp.solvebuffer=tmpquestion.solvebuffer
      this.applyPracticeAnswerToQuestion(ntmp);
      return ntmp;
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.pageindex = 1;
      this.currentPage = 1;
      this.getFilterQuestions();
      this.forceupdate();
    },
    on_clickPage(currentindx) {
      this.pageindex = currentindx;
      this.getFilterQuestions();
      this.forceupdate();
    },
    onSetKnowledges(sknowledges) {
      this.knowlegdes = sknowledges.datas;
    },
    onSetKnowledges_error() {},
    handleTableCurrentChange(selrow) {
      //console.log(selrow);
      if (selrow) {
        this.selquestion = selrow;
        this.selquestion.selquestion;
        this.$nextTick(() => {
          // this.updatequstionlatex();
        });
      }
    },
    onSetFilterQuestions(rsp) {
      // let arrs = rsp.data.map((item) => {
      //   return convertToFullQuestion(item); //解析时,是旧的数据没有js的,就传第二个参数为1,调用另一个方法
      // });
      this.parsing = Object.freeze(rsp.data);
      this.lockscreen = false;
      let rawKnowlegdquestions = [...rsp.data];
      let knowleqcs = rawKnowlegdquestions.length;
      //console.log(this.knowlegdquestions);
      for (let idx = 0; idx < knowleqcs; idx++) {
        let fixqt = rawKnowlegdquestions[idx];
        if (isEmpty(fixqt.steambuffer)) {
          fixqt.steambuffer = new Uint8Array();
        } else {
          fixqt.steambuffer = base64ToByteArray(fixqt.steambuffer);
        }
        if (isEmpty(fixqt.solvebuffer)) {
          fixqt.solvebuffer = new Uint8Array();
        } else {
          fixqt.solvebuffer = base64ToByteArray(fixqt.solvebuffer);
        }

        if (isEmpty(fixqt.answerbuffer)) {
          fixqt.answerbuffer = new Uint8Array();
        } else {
          fixqt.answerbuffer = base64ToByteArray(fixqt.answerbuffer);
        }
        fixqt.practiced = !!fixqt.practiced;
        fixqt.practiceOrder = idx + 1;
        rawKnowlegdquestions[idx] = fixqt;
      }
      this.knowlegdquestions = rawKnowlegdquestions;
      this.refreshPracticeStatsFromQuestionList();
      this.applyFilters();
    },
    refreshPracticeStatsFromQuestionList() {
      const questionTotal = Number(this.knowlegdquestions.length || 0);
      const answeredTotal = Number(
        this.knowlegdquestions.filter(item => item && item.practiced).length
      );
      const safeTotal = questionTotal > 0 ? questionTotal : 0;
      const completionRate =
        safeTotal <= 0
          ? "0.00"
          : ((answeredTotal * 100) / safeTotal).toFixed(2);
      this.practiceStats = {
        questionTotal: safeTotal,
        answeredTotal,
        correctTotal: 0,
        completionRate
      };
      this.practiceLastQuestionIndex = null;
    },
    getFilterQuestions() {
      this.questionffs = [];
      let startindex = (this.pageindex - 1) * this.pageSize;
      let endindex = Math.min(
        this.pageindex * this.pageSize,
        this.fliterlib.length
      );

      for (; startindex < endindex; startindex++) {
        let oldqt = this.fliterlib[startindex];
        let nqt = this.loadquestion(oldqt);
        nqt.id = startindex + 1;
        this.questionffs.push(nqt);
      }
    },
    onSetFilterQuestions_error(erro) {
      this.lockscreen = false;
      this.$notify.error({
        title: "错误",
        message: erro
      });
    },
    //选择知识点并加载题目
    async onClickKnowledgeItem(kgserialnumber) {
      this.lockscreen = true;
      await this.flushPracticeQueue(true);
      this.resetPracticeState();
      this.activeKnowledgeSerialnumber = kgserialnumber;
      this.selqtype = 7;
      this.sellevel = this.isClassic ? 0 : 3;
      this.pageindex = 1;
      this.currentPage = 1;
      try {
        let rsp;
        if (this.isClassic) {
          rsp = await getClassicQuestionList(kgserialnumber);
        } else {
          rsp = await getAllQuestion(this.radio1, kgserialnumber);
        }
        this.onSetFilterQuestions(rsp);
        this.loadDraftQueue();
        await this.flushPracticeQueue();
      } catch (erro) {
        this.onSetFilterQuestions_error(erro);
      } finally {
        this.lockscreen = false;
      }
    },
    forceupdate() {
      this.questionsels = [];
      this.$nextTick(() => {
        this.questionsels = this.questionffs;
      });
    },
    changshowmode() {
      this.getFilterQuestions();
      this.forceupdate();
    },
    onBeforeUnload() {
      this.saveDraftQueue();
    },
    resetPracticeState() {
      this.practiceStats = {
        questionTotal: 0,
        answeredTotal: 0,
        correctTotal: 0,
        completionRate: "0.00"
      };
      this.practiceAnsweredMap = {};
      this.practiceLastQuestionIndex = null;
      this.practicePendingQueue = [];
      this.practiceFlushing = false;
      this.practiceSyncFailed = false;
    },
    getDraftStorageKey() {
      if (!this.radio1 || !this.activeKnowledgeSerialnumber) {
        return "";
      }
      return `practice_draft_${this.radio1}_${this.activeKnowledgeSerialnumber}`;
    },
    saveDraftQueue() {
      const key = this.getDraftStorageKey();
      if (!key) {
        return;
      }
      if (!this.practicePendingQueue.length) {
        localStorage.removeItem(key);
        return;
      }
      const draft = {
        queue: this.practicePendingQueue,
        updateTime: Date.now()
      };
      localStorage.setItem(key, JSON.stringify(draft));
    },
    loadDraftQueue() {
      const key = this.getDraftStorageKey();
      if (!key) {
        return;
      }
      const raw = localStorage.getItem(key);
      if (!raw) {
        return;
      }
      try {
        const draft = JSON.parse(raw);
        if (draft && Array.isArray(draft.queue) && draft.queue.length) {
          this.practicePendingQueue = draft.queue.concat(
            this.practicePendingQueue
          );
        }
      } catch (e) {
        localStorage.removeItem(key);
      }
    },
    applyPracticeStats(summary) {
      if (!summary) {
        return;
      }
      const incomingQuestionTotal = Number(summary.questionTotal || 0);
      const knownQuestionTotal = Number(this.knowlegdquestions.length || 0);
      const questionTotal = Math.max(incomingQuestionTotal, knownQuestionTotal);
      this.practiceStats = {
        questionTotal,
        answeredTotal: Number(summary.answeredTotal || 0),
        correctTotal: Number(summary.correctTotal || 0),
        completionRate:
          questionTotal <= 0
            ? "0.00"
            : (
                (Number(summary.answeredTotal || 0) * 100) /
                questionTotal
              ).toFixed(2)
      };
      this.practiceLastQuestionIndex = summary.lastQuestionIndex || null;
    },
    buildPracticeAnswerMap(records) {
      const result = {};
      if (!Array.isArray(records)) {
        return result;
      }
      records.forEach(item => {
        if (item && item.questionId) {
          result[String(item.questionId)] = item;
        }
      });
      return result;
    },
    hasPracticeAnswer(questionId) {
      if (!questionId) {
        return false;
      }
      return !!this.practiceAnsweredMap[String(questionId)];
    },
    applyPracticeAnswerToQuestion(question) {
      if (!question || !question.questionId) {
        return;
      }
      question.practiced = !!(
        question.practiced || this.hasPracticeAnswer(question.questionId)
      );
      const record = this.practiceAnsweredMap[String(question.questionId)];
      if (!record || !record.studentAnswer) {
        return;
      }
      try {
        const answer = JSON.parse(record.studentAnswer);
        if (question.qtype === "单选题" && typeof answer === "string") {
          question.radio = answer;
        } else if (
          question.qtype === "判断题" &&
          typeof answer !== "undefined" &&
          answer !== null
        ) {
          question.radio = answer === true || answer === 1 ? 1 : 0;
        } else if (question.qtype === "多选题" && Array.isArray(answer)) {
          question.multx = answer;
        }
      } catch (e) {}
    },
    getQuestionTypeCode(question) {
      if (question && question.qtypeCode) {
        return question.qtypeCode;
      }
      switch ((question && question.qtype) || "") {
        case "判断题":
          return "JudgX";
        case "单选题":
          return "SingX";
        case "多选题":
          return "MultX";
        case "填空题":
          return "FillX";
        case "解答题":
          return "AnwsX";
        case "证明题":
          return "ProofX";
        default:
          return "All";
      }
    },
    buildStudentAnswer(question) {
      if (!question) {
        return null;
      }
      switch (question.qtype) {
        case "单选题":
          return question.radio || "";
        case "判断题":
          return question.radio === 1;
        case "多选题":
          return Array.isArray(question.multx)
            ? question.multx.slice().sort()
            : [];
        default:
          return null;
      }
    },
    getAnswerCostMillis() {
      if (!this.questionViewStartAt) {
        return null;
      }
      const cost = Date.now() - this.questionViewStartAt;
      return cost > 0 ? cost : null;
    },
    async saveCurrentQuestionProgress(isCorrect) {
      if (!this.question || !this.question.questionId) {
        return;
      }
      const answer = this.buildStudentAnswer(this.question);
      const questionOrder =
        this.question.questionOrder || this.question.id || 0;
      const payload = {
        courseSerialnumber: this.isClassic
          ? (this.question.courseSerialnumber || "classic")
          : this.radio1,
        knowledgeSerialnumber: this.activeKnowledgeSerialnumber,
        questionId: this.question.questionId,
        qtype: this.getQuestionTypeCode(this.question),
        questionOrder,
        studentAnswer: JSON.stringify(answer),
        isCorrect: typeof isCorrect === "boolean" ? (isCorrect ? 1 : 0) : null,
        costMillis: this.getAnswerCostMillis()
      };
      this.practiceAnsweredMap[String(this.question.questionId)] = {
        questionId: payload.questionId,
        questionOrder: payload.questionOrder,
        qtype: payload.qtype,
        studentAnswer: payload.studentAnswer,
        isCorrect: payload.isCorrect
      };
      this.markQuestionPracticed(payload.questionId);
      this.practiceLastQuestionIndex = questionOrder;
      this.enqueuePracticeSave(payload);
      this.forceupdate();
    },
    markQuestionPracticed(questionId) {
      if (!questionId) {
        return;
      }
      this.knowlegdquestions.forEach(item => {
        if (item && item.id === questionId) {
          item.practiced = true;
        }
      });
      this.fliterlib.forEach(item => {
        if (item && item.id === questionId) {
          item.practiced = true;
        }
      });
      this.questionffs.forEach(item => {
        if (item && item.questionId === questionId) {
          item.practiced = true;
        }
      });
      if (this.question && this.question.questionId === questionId) {
        this.question.practiced = true;
      }
      const questionTotal = Number(this.practiceStats.questionTotal || 0);
      const answeredTotal = Number(
        this.knowlegdquestions.filter(item => item && item.practiced).length
      );
      const completionRate =
        questionTotal <= 0
          ? "0.00"
          : ((answeredTotal * 100) / questionTotal).toFixed(2);
      this.practiceStats = {
        questionTotal,
        answeredTotal,
        correctTotal: Number(this.practiceStats.correctTotal || 0),
        completionRate
      };
    },
    enqueuePracticeSave(payload) {
      if (!payload) {
        return;
      }
      this.practicePendingQueue.push(payload);
      this.saveDraftQueue();
      this.flushPracticeQueue();
    },
    async flushPracticeQueue() {
      if (!this.practicePendingQueue.length) {
        this.saveDraftQueue();
        return;
      }
      if (this.practiceFlushing) {
        return;
      }
      this.practiceFlushing = true;
      try {
        while (this.practicePendingQueue.length > 0) {
          if (!getToken()) {
            this.practiceSyncFailed = true;
            this.saveDraftQueue();
            break;
          }
          const payload = this.practicePendingQueue[0];
          try {
            const res = await savePracticeRecord(payload);
            if (res && res.data) {
              this.applyPracticeStats(res.data);
            }
            this.practicePendingQueue.shift();
            this.practiceSyncFailed = false;
            this.saveDraftQueue();
          } catch (e) {
            this.practiceSyncFailed = true;
            this.saveDraftQueue();
            break;
          }
        }
      } finally {
        this.practiceFlushing = false;
      }
    },
    async finishCurrentPracticeSession() {
      await this.flushPracticeQueue(true);
    },
    tableRowClass({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "odd-row";
      }
      return "";
    }
  }
};
</script>

<style lang="scss" scoped>
#questionlib {
  background-color: #f5f7fa;
  height: calc(100vh - 48px);
  text-align: left;
}
.lib-wrapper {
  padding: 0;
  height: 100%;
}
.practice-progress {
  color: #409eff;
  font-size: 14px;
}
::v-deep .el-table .answered-row > td {
  background: #f0f9eb !important;
}
::v-deep .el-table .answered-row:hover > td {
  background: #e5f5df !important;
}
.el-table .odd-row {
  background: #eaeaea;
}
.lib-container {
  height: 100%;
  width: 100%;
}
.lib-sider {
  background-color: #fff;
  border-radius: 8px;
  padding: 20px 0;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  overflow-y: auto;
  scrollbar-color: transparent transparent;
  scrollbar-track-color: transparent;
  -ms-scrollbar-track-color: transparent;
  &::-webkit-scrollbar {
    display: none;
  }
}
.sider-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  padding: 0 20px;
  margin-top: 0;
  margin-bottom: 20px;
  text-align: left;
}
.course-list {
  padding: 0 20px;
  text-align: left;
}
.course-radio-group {
  width: 100%;
}
.course-radio-btn {
  width: 100%;
  margin-top: 10px;
  ::v-deep .el-radio-button__inner {
    border-radius: 4px !important;
    border: 1px solid #dcdfe6 !important;
    box-shadow: none !important;
    display: block;
    text-align: left;
    padding-left: 20px;
  }
}
.chapter-list {
  text-align: left;
  .back-course-btn {
    width: calc(100% - 40px);
    margin: 0 20px 15px 20px;
  }
}
.menu-sider {
  border-right: none !important;
  width: 100%;
  overflow-y: auto;
  text-align: left;
  &::-webkit-scrollbar {
    display: none;
  }
  ::v-deep .el-submenu__title {
    font-size: 16px;
    color: #333;
    padding-left: 20px !important;
  }
}
.el-menuitem-child {
  padding-left: 45px !important;
  color: #666;
  font-size: 14px;
  &.is-active {
    background-color: #e6f7ff !important;
    color: #409eff !important;
    font-weight: bold;
  }
}

.main-container {
  margin-left: 20px;
  flex-direction: column;
}
.lib-header {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  padding: 15px 20px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.filter-row {
  display: flex;
  align-items: center;
}
.filter-item {
  display: flex;
  align-items: center;
  margin-right: 25px;
}
.filter-label {
  margin-right: 10px;
  color: #606266;
  font-size: 14px;
}
.filter-select {
  width: 120px;
  ::v-deep .el-input__inner {
    border-color: #e4e7ed;
    background-color: #f5f7fa;
  }
}

.practice-stats-row {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}

.lib-main {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  padding: 20px 20px 0 20px;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.custom-table {
  width: 100%;
  ::v-deep .el-table__row > td {
    border-bottom: 1px solid #ebeef5;
  }
  ::v-deep::before {
    display: none;
  }
}
.level-tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  background-color: #e6f7ff;
  color: #409eff;
  font-size: 12px;
}
.action-btn {
  padding: 4px 8px;
  font-size: 14px;
}
.ai-action-btn {
  color: #409eff;
}

.ai-analysis-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 0.9fr) minmax(0, 1fr);
  gap: 16px;
  min-height: 520px;
}
.ai-obj-layout {
  display: grid;
  grid-template-columns: minmax(0, 0.8fr) minmax(0, 1fr) minmax(0, 1fr);
  gap: 16px;
  min-height: 0;
  height: 100%;
}
.ai-panel-result {
  overflow-y: auto;
}
::v-deep .ai-obj-dialog .el-dialog {
  height: 78vh;
  display: flex;
  flex-direction: column;
}
::v-deep .ai-obj-dialog .el-dialog__body {
  flex: 1;
  min-height: 0;
  overflow: hidden;
}
::v-deep .ai-obj-dialog .el-dialog__footer {
  flex-shrink: 0;
}
.ai-panel {
  border: 1px solid #ebeef5;
  border-radius: 8px;
  background: #fff;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.ai-panel-header {
  padding: 12px 14px;
  border-bottom: 1px solid #ebeef5;
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}
.ai-panel-body {
  padding: 12px 14px;
  overflow-y: auto;
  min-height: 0;
}
.ai-panel-question .tex2jax_ignore {
  font-size: 16px;
  font-family: inherit;
}
.ai-qcontent {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 8px;
}
.ai-qcontent img,
.ai-option-line img {
  max-width: 100%;
}
.ai-options-block {
  margin-top: 12px;
  border-top: 1px dashed #dcdfe6;
  padding-top: 10px;
}
.ai-block-title {
  margin: 0 0 8px;
  font-weight: 600;
  color: #606266;
}
.ai-option-line {
  margin-bottom: 8px;
  line-height: 1.6;
  color: #303133;
}
.ai-option-label {
  margin-right: 4px;
  font-weight: 600;
}
.ai-upload-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}
.ai-upload-tip {
  margin: 0 0 10px;
  color: #909399;
  font-size: 12px;
}
.ai-upload-preview-box {
  border: 1px dashed #dcdfe6;
  border-radius: 6px;
  min-height: 280px;
  background: #fafafa;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
}
.ai-upload-preview-wrap {
  width: 100%;
  text-align: center;
}
.ai-upload-preview {
  max-width: 100%;
  max-height: 360px;
  object-fit: contain;
}
.ai-upload-placeholder {
  text-align: center;
  color: #909399;
}
.ai-upload-placeholder i {
  font-size: 38px;
  margin-bottom: 8px;
}
.ai-result-card {
  border: 1px solid #ebeef5;
  border-radius: 6px;
  padding: 10px 12px;
  background: #f8fbff;
}
.ai-result-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.ai-meta-list {
  margin-top: 10px;
}
.ai-meta-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}
.ai-meta-value {
  color: #303133;
  max-width: 70%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ai-result-label {
  color: #606266;
  font-size: 13px;
}
.ai-result-error {
  margin-top: 12px;
  padding: 10px 12px;
  border: 1px solid #fde2e2;
  border-radius: 6px;
  background: #fef0f0;
  color: #f56c6c;
}
.ai-result-error h4 {
  margin: 0 0 6px;
  color: #f56c6c;
}
.ai-result-error p {
  margin: 0;
  line-height: 1.6;
  word-break: break-all;
}
.ai-result-section {
  margin-top: 14px;
}
.ai-result-section h4 {
  margin: 0 0 6px;
  color: #303133;
}
.ai-text-block {
  margin: 0;
  padding: 10px 12px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  background: #fff;
  color: #606266;
  line-height: 1.7;
  font-size: 13px;
  white-space: pre-wrap;
  word-break: break-word;
  font-family: inherit;
}
.ai-rich-content {
  white-space: normal;
}
::v-deep .ai-rich-content .ai-rich-line {
  margin: 0 0 8px;
  line-height: 1.85;
}
::v-deep .ai-rich-content .ai-rich-line:last-child {
  margin-bottom: 0;
}
::v-deep .ai-rich-content strong {
  font-weight: 700;
  color: #303133;
}
::v-deep .ai-rich-content .ai-rich-section {
  margin-top: 4px;
  font-size: 14px;
  color: #303133;
}
::v-deep .ai-rich-content .ai-rich-option,
::v-deep .ai-rich-content .ai-rich-bullet {
  padding-left: 6px;
}
.ai-latex-content .katex-display {
  margin: 8px 0;
  overflow-x: auto;
}
.ai-latex-content .katex {
  font-size: 1.1em;
}
.ai-solving-tip {
  margin-top: 12px;
  color: #e6a23c;
}
.ai-transfer-loading {
  margin: 0;
  padding: 10px 12px;
  border: 1px dashed #dcdfe6;
  border-radius: 6px;
  color: #909399;
  background: #fafafa;
}

@media (max-width: 1600px) {
  .ai-obj-layout {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 1200px) {
  .ai-analysis-layout {
    grid-template-columns: 1fr;
  }
  .ai-obj-layout {
    grid-template-columns: 1fr;
  }
  .ai-upload-preview-box {
    min-height: 220px;
  }
}

.qsplit {
  margin-bottom: 10px;
  margin-top: 10px;
  font-size: 24px;
  font-family: "宋体";
  font-weight: bold;
}
.qcontent {
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -ms-flex-line-pack: start;
  align-content: flex-start;
  background: transparent;
  text-align: left;
}
.qoption {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  align-content: flex-start;
}
.qtext {
  font-size: 20px;
  font-family: "宋体";
}
.el-selbtn {
  margin-top: 10px;
}
.el-row-line {
  border-radius: 4px;
  height: 20px;
}
.tex2jax_ignore {
  font-size: 24px;
  font-family: "宋体";
}
::v-deep .el-radio-button__inner {
  width: 100%;
}
.count-badge {
  display: inline-block;
  margin-left: 6px;
  font-size: 12px;
  color: #909399;
  &.has-count {
    color: #409eff;
    font-weight: bold;
  }
}
</style>
